import React from 'react';
import queryString from 'query-string';
import snakeCaseKeys from 'snakecase-keys';
import API from 'shared/constants/api';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import Link from 'shared/components/Link';
import currencies from 'shared/constants/json/currency.json';
import Carousel from '../Carousel/Carousel';
import AdvertCard from '../AdvertCard/AdvertCard';
import { withFetch } from '../../../shared/hocs/withFetch';
import s from './TopAvtosalon.css';

const uah = currencies.find(item => item.slug === 'uah');
const PER_PAGE = 20;
const IMAGE_WIDTH = 240;

const fetchTopDealer = (fetch, params) =>
  fetch(
    API.DEALERS.ALL(
      `?${queryString.stringify(
        snakeCaseKeys({
          isTop: 1,
          perPage: 1,
          ...params,
        }),
      )}`,
    ),
  ).then(r => r.json());

const fetchTopDealerCars = (fetch, dealer, params) => {
  if (!dealer) {
    return Promise.resolve();
  }

  return fetch(
    API.ADVERT.ALL(
      `?${queryString.stringify(
        snakeCaseKeys({
          dealer: dealer.id,
          perPage: PER_PAGE,
          ...(params && params.transport ? { transport: params.transport } : {}),
        }),
      )}`,
    ),
  ).then(r => r.json());
};
// eslint-disable-next-line no-unused-vars
const fetchDealer = async data => {
  const { additionParams, fetch } = data.props;

  data.setState({ dealer: null, cars: null, isFetching: true });

  return Promise.all([fetchTopDealer(fetch, additionParams)]).then(([dealers]) => {
    const dealer = (dealers && dealers[0]) || null;
    data.setState({ dealer, isFetching: false });
  });
};

// eslint-disable-next-line no-unused-vars
const fetchDealerCars = async data => {
  const { dealer } = data.state;
  const { additionParams = {}, fetch } = data.props;

  if (!dealer) {
    return Promise.resolve();
  }

  data.setState({ cars: null, isFetching: true });

  return Promise.all([fetchTopDealerCars(fetch, dealer, additionParams)]).then(([cars]) =>
    data.setState({ cars: cars.results, isFetching: false }),
  );
};
class TopAvtosalon extends React.Component {
  state = {
    dealer: null,
    cars: null,
    isFetching: false,
  };

  componentWillMount() {
    /** temporary solution * */
    // fetchDealer(this);
    // fetchDealerCars(this);
  }

  render() {
    const { dealer, cars: fetchedCars } = this.state;
    if (!dealer) {
      return null;
    }

    const cars = fetchedCars && fetchedCars.length > 0 ? fetchedCars.slice(0, 20) : null;

    const { adverts_count: advertsCount } = dealer;
    const imageStyles = { height: '200px' };
    const avtosalonUrl = `/avtosalony/${dealer.slug}/`;

    return (
      <div className={s.root}>
        <div className={s.head}>
          <Link to={avtosalonUrl} className={s.title}>
            {dealer.title}
          </Link>
          <div className={s.adr}>
            {dealer.address}
          </div>

          {dealer.logo &&
            <div className={s.logo}>
              <img src={dealer.logo} width="60" alt="" />
            </div>}
        </div>
        {cars &&
          <Carousel
            step={1}
            itemsInRow={1}
            loop
            classNames={{
              body: s.carouselBody,
            }}
            header={
              <div className={s.count}>
                {advertsCount} <FormattedMessage id="объявлений" />
              </div>
            }
            items={cars.map(car =>
              <AdvertCard
                key={car.id}
                item={car}
                currency={uah}
                cardType="simple"
                imageStyle={imageStyles}
                advertClassName={s.advertItem}
                advertThumbClassName={s.advertThumbItem}
                width={IMAGE_WIDTH}
              />,
            )}
          />}
      </div>
    );
  }
}

export default withStyles(s)(withFetch(TopAvtosalon));



// WEBPACK FOOTER //
// ./src/desktop/components/TopAvtosalon/TopAvtosalon.js